'use client';
import Image from 'next/image';
import { useTranslations } from '@/app/providers';
import { SectionHeader } from '@/components/common/section-header';
import { SectionCard } from '@/components/common/section-card';
import { RotatingContactButton } from '@/components/ui/rotating-contact-button';

const HowWeDoIt = () => {
  const t = useTranslations();

  return (
    <section id='come-lo-facciamo' className='relative w-full py-28 lg:py-34 mt-16 md:mt-0'>
      <div className='container mx-auto px-6 lg:px-0'>
        <div className='relative'>
          {/* Pulsante posizionato in alto a destra, metà dentro e metà fuori */}
          <div className='absolute -top-20 right-4 md:-top-24 md:right-24 z-20'>
            <RotatingContactButton />
          </div>

          <div className='relative'>
            {/* Blob dietro la card (z-index inferiore) */}
            <div className='absolute -top-36 -left-16 pointer-events-none -z-10'>
              <Image
                src='/Blob background (2).png'
                alt=''
                width={787}
                height={647}
                priority={false}
                aria-hidden='true'
              />
            </div>

            <SectionCard withGradient paddingClassName='p-[2rem] md:p-[5.5rem]'>
              <div className='grid grid-cols-1 lg:grid-cols-2 lg:gap-8'>
                <div>
                  <SectionHeader label={t.howWeDoIt.label} title={t.howWeDoIt.title} />
                </div>
                <div className='space-y-4 mt-11'>
                  <p className='text-brand-violet-100 text-base font-normal leading-relaxed whitespace-pre-line'>
                    {t.howWeDoIt.description1}
                  </p>
                  <p className='text-brand-violet-100 text-base font-normal leading-relaxed whitespace-pre-line'>
                    {t.howWeDoIt.description2}
                  </p>
                </div>
              </div>
            </SectionCard>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeDoIt;
